import React from 'react';

const BootstrapRow = (props) =>
{
	const classAdd =  props.className !== undefined ? ' ' + props.className : '' ;

	return <div className={'row' + classAdd} style={props.style}>{props.children}</div>
}

export default BootstrapRow ;